var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-text-field',{attrs:{"outlined":"","dense":"","single-line":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }